// import React, { useState } from 'react';
// import { makeStyles } from '@mui/styles';
// import Modal from '@mui/material/Modal';
// import style from '../Tools/Style';
// import TextField from '@mui/material/TextField';
// import SearchIcon from '@mui/icons-material/Search';
// import { CircularProgress, Typography, Grid } from '@mui/material';
// import TClientes from './Clientes/TClientes';

// function rand() {
//   return Math.round(1 * 20) - 10;
// }

// function getModalStyle() {
//   const top = 50 + rand();
//   const left = 50 + rand();

//   return {
//     top: `${top}%`,
//     left: `${left}%`,
//     transform: `translate(-${top}%, -${left}%)`,
//   };
// }

// const useStyles = makeStyles((theme) => ({
//   paper: {
//     position: 'absolute',
//     width: '80%',
//     backgroundColor: theme.palette.background.paper,
//     border: '2px solid #000',
//     boxShadow: theme.shadows[5],
//     padding: theme.spacing(2, 4, 3),
//     outline: 0,
//   },
// }));

// export default function ModalClientes({
//   open,
//   handleClose,
//   data,
//   seleccionarCliente,
//   datosCargados,
// }) {
//   const classes = useStyles();

//   const [modalStyle] = React.useState(getModalStyle);

//   const [termc, setTermc] = useState('');

//   const handleCloseModal = () => {
//     handleClose();
//     setTermc('');
//   };

//   const body = (
//     <div style={modalStyle} className={classes.paper}>
//       <Typography
//         id="simple-modal-title"
//         component="h3"
//         variant="h4"
//         color="primary"
//       >
//         Buscar Clientes
//       </Typography>

//       <SearchIcon style={style.iconbuscar} />
//       <TextField
//         name="term"
//         style={style.TextFieldbuscar}
//         onChange={(e) => setTermc(e.target.value)}
//         label="Buscar"
//       />
//       <div notranslate="true">
//         {datosCargados ? (
//           <TClientes
//             rows={data}
//             seleccionar={seleccionarCliente}
//             termc={termc}
//             setTermc={setTermc}
//           />
//         ) : (
//           <Grid container justify="center">
//             <CircularProgress />
//             <br />
//             <Typography>Cargando...</Typography>
//           </Grid>
//         )}
//       </div>
//     </div>
//   );
//   return (
//     <React.Fragment>
//       <Modal
//         open={open}
//         onClose={handleCloseModal}
//         aria-labelledby="simple-modal-title"
//         aria-describedby="simple-modal-description"
//       >
//         {body}
//       </Modal>
//     </React.Fragment>
//   );
// }
import React, { useState, useEffect } from 'react';
import { makeStyles } from '@mui/styles';
import Modal from '@mui/material/Modal';
import style from '../Tools/Style';
import TextField from '@mui/material/TextField';
import SearchIcon from '@mui/icons-material/Search';
import {
  CircularProgress,
  Typography,
  Grid,
  Pagination,
  Box,
} from '@mui/material';
import TClientes from './Clientes/TClientes';

function rand() {
  return Math.round(1 * 20) - 10;
}

function getModalStyle() {
  const top = 50 + rand();
  const left = 50 + rand();

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles((theme) => ({
  paper: {
    position: 'absolute',
    width: '80%',
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    outline: 0,
    maxHeight: '90vh',
    overflowY: 'auto',
  },
}));

export default function ModalClientes({
  open,
  handleClose,
  data,
  seleccionarCliente,
  datosCargados,

  // nuevos props para paginado
  totalRegistros = 0,
  pagina = 1,
  tamanoPagina = 20,
  buscarCliente = '',
  onBuscarCliente,
  onCambiarPagina,
}) {
  const classes = useStyles();

  const [modalStyle] = React.useState(getModalStyle);
  const [termc, setTermc] = useState(buscarCliente || '');

  // Sincroniza el buscador interno con el valor que viene del padre
  useEffect(() => {
    setTermc(buscarCliente || '');
  }, [buscarCliente]);

  // Buscador con pequeño delay para no llamar al backend en cada tecla inmediatamente
  useEffect(() => {
    if (!open) return;

    if (!onBuscarCliente) return;

    const timer = setTimeout(() => {
      onBuscarCliente(termc);
    }, 600);

    return () => clearTimeout(timer);
  }, [termc, open]);

  const handleCloseModal = () => {
    setTermc('');

    if (onBuscarCliente) {
      onBuscarCliente('');
    }

    handleClose();
  };

  const cantidadPaginas = Math.ceil(totalRegistros / tamanoPagina);

  const body = (
    <div style={modalStyle} className={classes.paper}>
      <Typography
        id="simple-modal-title"
        component="h3"
        variant="h4"
        color="primary"
      >
        Buscar Clientes
      </Typography>

      <Box sx={{ display: 'flex', alignItems: 'center', mt: 2, mb: 2 }}>
        <SearchIcon style={style.iconbuscar} />

        <TextField
          name="term"
          style={style.TextFieldbuscar}
          value={termc}
          onChange={(e) => setTermc(e.target.value)}
          label="Buscar"
          placeholder="Buscar por nombre, apellido, RUC, CI..."
        />
      </Box>

      <div notranslate="true">
        {datosCargados ? (
          <>
            <TClientes
              rows={data}
              seleccionar={seleccionarCliente}

              // Si estás usando búsqueda paginada del backend,
              // conviene no filtrar nuevamente en TClientes.
              // Por eso mandamos vacío cuando existe onBuscarCliente.
              termc={onBuscarCliente ? '' : termc}
              setTermc={setTermc}
                paginacionExterna={Boolean(
    onBuscarCliente
  )}
            />

            {onCambiarPagina && cantidadPaginas > 1 && (
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  mt: 3,
                }}
              >
                <Pagination
                  count={cantidadPaginas}
                  page={pagina}
                  color="primary"
                  onChange={(event, value) => {
                    onCambiarPagina(value);
                  }}
                />
              </Box>
            )}

            {totalRegistros > 0 && (
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ textAlign: 'center', mt: 1 }}
              >
                Total de clientes encontrados: {totalRegistros}
              </Typography>
            )}
          </>
        ) : (
          <Grid container justifyContent="center" sx={{ mt: 4 }}>
            <CircularProgress />
            <br />
            <Typography sx={{ ml: 2 }}>Cargando...</Typography>
          </Grid>
        )}
      </div>
    </div>
  );

  return (
    <React.Fragment>
      <Modal
        open={open}
        onClose={handleCloseModal}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        {body}
      </Modal>
    </React.Fragment>
  );
}